import { motion } from 'framer-motion';

const About = () => {
    return (
        <section id="about" className="section">
            <div className="container">
                <div className="grid md:grid-cols-2 gap-16 items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="relative"
                    >
                        <div className="relative z-10 rounded-2xl overflow-hidden grayscale hover:grayscale-0 transition-all duration-700">
                            <img
                                src="./tarush.png"
                                alt="Tarush Agarwal"
                                className="w-full object-cover rounded-2xl"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-60"></div>
                        </div>
                        {/* Decorative Frame */}
                        <div className="absolute -top-4 -left-4 w-full h-full border border-white/10 rounded-2xl -z-0"></div>
                        <div className="absolute -bottom-4 -right-4 w-full h-full border border-primary-purple/30 rounded-2xl -z-0"></div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="flex items-center gap-4 mb-8">
                            <span className="w-12 h-[1px] bg-primary-purple"></span>
                            <span className="text-primary-purple uppercase tracking-widest text-sm font-medium">About Me</span>
                        </div>

                        <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight">
                            Passionate about <br />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-purple to-secondary-blue">Future Tech.</span>
                        </h2>

                        <p className="text-lg text-gray-400 mb-8 leading-relaxed font-light">
                            I'm Tarush Agarwal, a Computer Science Engineering graduate from VIT Vellore (July 2026). I don't just write code; I architect solutions. My journey is defined by a relentless pursuit of innovation in AI, Cloud Computing, and Full Stack Development.
                        </p>

                        <div className="space-y-4">
                            {[
                                "AWS & Oracle Cloud Certified Professional",
                                "SWE at Caterpillar Inc."
                            ].map((item, index) => (
                                <div key={index} className="flex items-center gap-4 group">
                                    <div className="w-2 h-2 rounded-full bg-white group-hover:bg-primary-purple transition-colors"></div>
                                    <span className="text-gray-300 group-hover:text-white transition-colors text-lg">{item}</span>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default About;
